import React from 'react';
import { Container } from "react-bootstrap";
import { Title, SiteSearch } from 'components';
import styled from 'styled-components'
import { device } from 'utils/device';

const SearchPage = () => {
  return (
    <SearchContainer fluid>
      <Title>Program Search</Title>
      <SiteSearch />
    </SearchContainer>
  );
};

const SearchContainer = styled(Container)`
  margin: 2rem auto;
  max-width: 80%;

  @media ${device.tablet} {
    max-width: 95%;
  }
`;

export default SearchPage;
